import axios from 'axios';
import axiosCancel from 'axios-cancel';
import camelcaseKeys from 'camelcase-keys';
import ProjectFunctionCategories from './testPayloads/ProjectFunctionCategories';
import _ from 'lodash';
import TestProjectFunctions, { TestProjectFunctionsNotAssigned, TestProjectNoAccess, TestFunctionNotifications } from './testPayloads/AllProjectFunctions';
import FunctionNotifications from './testPayloads/FunctionNotifications';

class WebServices {

  validateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return (true)
    }
    return (false)
  }

  constructor() {

    this.api = axios.create({
      headers: {
        'Access-Control-Allow-Origin': '*'
      },
      withCredentials: true,

      validateStatus: function (status) {

        if (status === 401) {
          // var host = window.location.hostname;

          // if (host === 'localhost') {
          //   window.location.href = '/api/sso/login/localhost';

          // } else {
          //   window.location.href = '/api/sso/login';
          // }
          if (window.location.pathname !== '/api/b2c/signin') {
            window.location.href = '/api/b2c/signin';
          }

        }

        return status >= 200 && status < 300; // default
      },
    });

    this.api.interceptors.request.use(
      config => {

        const authID = document.cookie.match(new RegExp('(^| )AuthID=([^;]+)'));
        const eventID = document.cookie.match(new RegExp('(^| )EVENTS_ID_OVERRIDE=([^;]+)'));

        if (authID) {

          config.headers['X-NSE-AuthID'] = authID[2];

        }

        if (eventID) {

          config.headers['X-myPSN-OverrideEventID'] = eventID[2];

        }

        return config;
      },
      error => Promise.reject(error)
    );



    axiosCancel(axios, {
      debug: true // default
    });



  }

  searchActiveDirectory(searchTerm) {

    const isSearchTermEmailAddress = this.validateEmail(searchTerm);



    let requestId = 'searchActiveDirectory';

    axios.cancel(requestId);

    if (isSearchTermEmailAddress) {
      return new Promise((resolve, reject) => {
        this.api.post(`/api/admin/validateBpaAccount?email=${searchTerm}`, { requestId })
          .then(json => {

            if (json.data.result.isValid) {
              resolve(camelcaseKeys([{ ...json.data.result, bun: json.data.result.email, isBpa: true, name: `${json.data.result.firstName} ${json.data.result.lastName}` }]), searchTerm);

            } else {
              resolve(camelcaseKeys([]), searchTerm);

            }
          })
          .catch((error) => {
            console.log("searchActiveDirectory Error");

            reject(error);
          });
      });
    } else {

      return new Promise((resolve, reject) => {
        this.api.get(`/api/users/galsearch?q=${searchTerm}`, { requestId })
          .then(json => {
            const { result } = json.data || {};
            const normalizedResult = Array.isArray(result)
              ? result
              : (result && Array.isArray(result.users) ? result.users : []);
            resolve(camelcaseKeys(normalizedResult), searchTerm);
          })
          .catch((error) => {
            console.log("searchActiveDirectory Error");

            reject(error);
          });
      });
    }


  }

  searchAppUser(searchTerm) {

    const isSearchTermEmailAddress = this.validateEmail(searchTerm);



    let requestId = 'searchAppUser';

    axios.cancel(requestId);

    

      return new Promise((resolve, reject) => {
        this.api.get(`/api/users/appUsersSearch?q=${searchTerm}`, { requestId })
          .then(json => {
            const { result } = json.data || {};
            const normalizedResult = Array.isArray(result)
              ? result
              : (result && Array.isArray(result.users) ? result.users : []);
            resolve(camelcaseKeys(normalizedResult), searchTerm);
          })
          .catch((error) => {
            console.log("searchAppUser Error");

            reject(error);
          });
      });
    


  }

  addUser(bun) {
    const encodedBun = encodeURIComponent(bun)
    return new Promise((resolve, reject) => {
      this.api.post(`/api/admin/addUser?bun=${encodedBun}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //resolve(AddUser.result);

          reject(error);
        });
    });
  }

  deleteUser(id) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/users/delete/${id}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //resolve(AddUser.result);

          reject(error);
        });
    });
  }

  updateIWPPAprovers(workflowSteps, gbuId) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/workflow/updateIwppApprovers/${gbuId}`, workflowSteps)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  deleteIWPPAproverStep(id) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/workflow/deleteIwppApproverStep/${id}`)
        .then(json => {
          resolve(json.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getMyProjectFunctions() {


    return new Promise((resolve, reject) => {
      this.api.get(`/api/actions/myProjectFunctions`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  actiontsProjectFunctionDetails({ projectId, functionId }) {

    return new Promise((resolve, reject) => {
      this.api.get(`/api/actions/projectfunctiondetails/${projectId}/${functionId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });

  }

  getIWPPApprovers(gbuId) {
    return new Promise((resolve, reject) => {
      this.api.get(`/api/workflow/getIwppApprovers/${gbuId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {

          reject(error);
        });
    });
  }


  addProject(project) {
    return new Promise((resolve, reject) => {
      this.api.post('api/project/add', project)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {

          reject(error);
          
        });
    });
  }

  getUsers() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/users/all')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //  resolve(Users.result);

          reject(error);
        });
    });
  }

  updateAction(action) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/actions/update/${action.procedureId}`, action)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  updateAllAction(projectId, functionId, action) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/actions/updateAll/${projectId}/${functionId}`, action)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  submitPendingActions(pendingActions) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/actions/submitPending`, pendingActions)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  updateProcedureManualHeader(headerInfo) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/procedures/updateProcedureManualHeader`, headerInfo)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getProcedureManual({ projectId, functionId }) {
    return new Promise((resolve, reject) => {
      this.api.get(`/api/project/procedureManual/${functionId}/${projectId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  impersonate(bun) {

    let url = !bun ? '/api/b2c/impersonate' : '/api/b2c/impersonate/' + bun;
    return new Promise((resolve, reject) => {
      this.api.get(url)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {

          reject(error);
        });
    });
  }

  getUserDetails(userId) {
    return new Promise((resolve, reject) => {
      this.api.get(`/api/admin/userDetails/${userId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //  resolve(UserDetails.result);

          reject(error);
        });
    });
  }


  getFunctions() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/functions/userfunctions')
        .then(json => {
          const result = camelcaseKeys(json.data.result);
          resolve(result);
        })
        .catch(error => {
          //resolve(Functions.result);

          reject(error);
        });
    });
  }

  getMyRrDocs() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/myrr/myRrDocs')
        .then(json => {
          const result = camelcaseKeys(json.data.result);
          resolve(result);
        })
        .catch(error => {
          //resolve(Functions.result);

          reject(error);
        });
    });
  }

  getProjectFunctionCategories({ functionId, projectId }) {



    return new Promise((resolve, reject) => {
      this.api.get(`/api/project/functionProcedureCategories/${functionId}/${projectId}`)
        .then(json => {
          resolve(_.sortBy(json.data.result, 'name'));
        })
        .catch(error => {
          resolve(error);
        });
    });

  }

  importFunctionProcedureCategories({ functionId, projectId, categories }) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/project/importFunctionProcedureCategories/${functionId}/${projectId}`, categories)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });

  }


  getAvailableProjects() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/project/AllProjects')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });

  }

  getJADBProjects() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/project/JADBProjects')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });

  }


  saveProjectFunctions({ functions, projectId }) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/project/saveProjectFunctions/${projectId}`, functions)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //  resolve(SaveProjectFunctions.result);

          reject(error);
        });
    });

  }

  getProjects() {
    return new Promise((resolve, reject) => {
      this.api.get('api/gbu/GBUAdmin ')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //   resolve(GBUAdmin.result);

        });
    });
  }

  getGBUs() {
    return new Promise((resolve, reject) => {
      this.api.get('api/gbu/GBUs ')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //   resolve(GBUAdmin.result);

        });
    });
  }

  getActions() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/actions/mine')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          // resolve(Actions.result);

          reject(error);
        });
    });
  }

  submitActions(actions) {
    return new Promise((resolve, reject) => {
      this.api.post('/api/actions/mine', actions)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //  resolve(ActionsSubmit.result);

          reject(error);
        });
    });
  }


  oneTimeDeviation(deviation) {
    return new Promise((resolve, reject) => {
      this.api.post('/api/actions/oneTimeDeviation', deviation)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  submitActionsWithApprovedUpdates(actions) {
    return new Promise((resolve, reject) => {
      this.api.post('/api/actions/mineV2', actions)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //  resolve(ActionsSubmit.result);

          reject(error);
        });
    });
  }

  postUserDetails(userDetails) {
    return new Promise((resolve, reject) => {
      this.api.post('/api/admin/userPermissionsUpdate', userDetails)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {

          reject(error);
        });
    });
  }

  getFunctionDetails(aFunction) {
    return new Promise((resolve, reject) => {
      this.api.get('api/functions/functionDetails/' + aFunction.id)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          //resolve(FunctionDetails.result);
          reject(error);
        });
    });
  }

  saveProcedure(procedure) {
    return new Promise((resolve, reject) => {
      this.api.post('/api/procedures/save', procedure)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          // resolve(FunctionDetails.result);
          reject(error);
        });
    });
  }

  deleteDeviationFile(deviationFileId) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/attachments/deleteInProgressAttachment/${deviationFileId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getProjectSpecificProcedures({ functionId, projectId }) {
    return new Promise((resolve, reject) => {
      this.api.get(`/api/functions/projectSpecificProcedures/${functionId}/${projectId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  importFunctionProcedures({ functionId, projectId }) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/project/importFunctionProcedures/${functionId}/${projectId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  createProcedureManual({ functionId, projectId }) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/procedures/createProcedureManual/${functionId}/${projectId}`)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  uploadDeviationFiles({ files, procedureId }) {

    const data = new FormData();

    for (const file of files) {
      data.append('file', file, file.name);
    }
    return new Promise((resolve, reject) => {
      this.api.post(`/api/procedures/UploadInProgressAttachments/${procedureId}`, data, {
        headers: {
          'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        },
        timeout: 30000,
      })
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });

  }

  getProjectFunctionDetails({ functionId, projectId, gbuId }) {


    const path = gbuId ? `/api/functions/GBUAdminGBUFunctionDetails/${functionId}/${gbuId}` : `/api/functions/GBUAdminProjectFunctionDetails/${functionId}/${projectId}`;

    return new Promise((resolve, reject) => {
      this.api.get(path)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  updateWorkflowApprovers({ workflowStepsToUpdate, isGbu, id, functionId }) {

    const apiPath = isGbu ? `/api/workflow/updateGbuWorkflowApprovers/${functionId}/${id}` : `/api/workflow/updateProjectWorkflowApprovers/${functionId}/${id}`

    console.log(JSON.stringify(workflowStepsToUpdate));

    return new Promise((resolve, reject) => {
      this.api.post(apiPath, workflowStepsToUpdate)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          // resolve(FunctionDetails.result);
          reject(error);
        });
    });
  }

  updateWorkflow({ workflowStepsToUpdate, functionId }) {


    console.log(JSON.stringify(workflowStepsToUpdate));

    return new Promise((resolve, reject) => {
      this.api.post('api/workflow/SaveFunctionWorkflowAndAutoApprovedFlag/' + functionId, workflowStepsToUpdate)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          // resolve(FunctionDetails.result);
          reject(error);
        });
    });
  }


  getAboutCurrentUser() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/aboutme')
        .then(json => {
          resolve(camelcaseKeys(json.data.result));
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  getFunctionCategories(functionId) {
    return new Promise((resolve, reject) => {
      this.api.get('/api/functions/Categories/' + functionId)
        .then(json => {

          resolve(_.orderBy(json.data.result, 'name'));
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  updateFunctionCategories(categoriesToUpdate, functionId) {


    return new Promise((resolve, reject) => {
      this.api.post('/api/functions/UpdateCategories/' + functionId, categoriesToUpdate)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }


  getWakeup() {
    return new Promise((resolve, reject) => {
      this.api.get('/api/wakeup')
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  addProcedureToFunctionWorkflow(procedureId, functionId) {
    return new Promise((resolve, reject) => {
      this.api.post(`/api/procedures/addToFunctionWf/${procedureId}/${functionId}`)
        .then(json => {
          resolve(json.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  addAllProceduresToFunctionWorkflow(functionId, projectId) {

    const projectIdParam = projectId ? `/${projectId}` : '';

    return new Promise((resolve, reject) => {
      this.api.post(`/api/procedures/addAllToFunctionWf/${functionId}${projectIdParam}`)
        .then(json => {
          resolve(json.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  updateFunctionNotifications({ workflowStep, functionId }) {

    console.log(JSON.stringify(workflowStep));

    return new Promise((resolve, reject) => {
      this.api.post(`api/functions/updateFunctionNotifications/${functionId}`, workflowStep)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  updateProject({ projectToUpdate }) {
    console.log(JSON.stringify(projectToUpdate));

    return new Promise((resolve, reject) => {
      this.api.post(`api/project/updateProject`, projectToUpdate)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  saveActionProcedureComment(commentToSave) {
    return new Promise((resolve, reject) => {
      this.api.post('/api/procedures/saveComment', commentToSave)
        .then(json => {
          resolve(json.data.result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

}

export default WebServices;